// Axios
import Axios from "./axios"

export const deleteNews = (id) => {
    return new Promise((resolve, reject) => {
        const data = Axios.delete(`/news/${id}`, {
            headers: {
                'access-token': localStorage.getItem("access_token")
            }
        })
        setTimeout(() => resolve(data), 0)
    })

}